export default "__VITE_ASSET__Cj9qQ1fB__"